const hero = document.querySelector('[id$="__slideshow_home_hero"]');

if (hero) {
  let frame;
  const measure = () => {
    const bars = document.querySelectorAll('.hdt-top-bar-section, .hdt-announcement-bar-section');
    const offset = `${Math.round([...bars].reduce((height, bar) => height + bar.getBoundingClientRect().height, 0))}px`;
    if (hero.style.getPropertyValue('--gh-hero-top-space') !== offset) {
      hero.style.setProperty('--gh-hero-top-space', offset);
    }
  };
  const schedule = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(measure);
  };

  measure();
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('pageshow', schedule);
  if ('ResizeObserver' in window) {
    const observer = new ResizeObserver(schedule);
    document.querySelectorAll('.hdt-top-bar-section, .hdt-announcement-bar-section').forEach(element => observer.observe(element));
  }
}
